import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Lesson } from './lesson.model';
import { LessonService } from './lesson.service';
import { error } from 'console';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class LessonPopupService {
    private isOpen = false;
    private defaultStatus: any = 'OPEN';
    private defaultBeginning: Date;
    private defaultEnding: Date;
    private defaultMinParticipants = 1;
    private defaultMaxParticipants = 18;
    private defaultReminderPolicy = 48;
    private defaultReservationCancellationPolicy = 24;
    private defaultVideoConferenceValue = false;
    private defaultPublished = false;

    constructor(
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private lessonService: LessonService
    ) { }

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.lessonService.find(id)
                .subscribe(lesson => {
                    this.lessonModalRef(component, lesson);
                }, (error: HttpErrorResponse) => {
                    this.isOpen = false;
                });
        } else {
            let lesson: Lesson = new Lesson();
            this.defaultBeginning = new Date();
            this.defaultBeginning.setHours(7, 0);
            this.defaultEnding = new Date(this.defaultBeginning);
            this.defaultEnding.setHours(this.defaultEnding.getHours() + 1);
            this.defaultEnding.setMinutes(this.defaultEnding.getMinutes() + 30);
            lesson.begining = this.defaultBeginning;
            lesson.ending = this.defaultEnding;
            lesson.minParticipants = this.defaultMinParticipants;
            lesson.maxParticipants = this.defaultMaxParticipants;
            lesson.reminderPolicy = this.defaultReminderPolicy;
            lesson.reservationCancellationPolicy = this.defaultReservationCancellationPolicy;
            lesson.status = this.defaultStatus;
            lesson.videoConference = this.defaultVideoConferenceValue;
            lesson.published = this.defaultPublished;
            setTimeout(() => {
                // the setTimeout is needed to avoid ExpressionChangedAfterItHasBeenCheckedError error in dev mode
                return this.lessonModalRef(component, lesson);
            });
        }
    }

    lessonModalRef(component: Component, lesson: Lesson): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.lesson = lesson;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson/lesson-popup.service.ts